import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons"

interface ColumnGroup {
  title: string
  columns: any[]
  isExpanded?: boolean
}

interface GroupedColumnsProps {
  groups: ColumnGroup[]
  onGroupToggle: (groupIndex: number) => void
}

const GroupedColumns: React.FC<GroupedColumnsProps> = ({ groups, onGroupToggle }) => {
  return (
    <div className="flex flex-wrap gap-2 mb-4">
      {groups.map((group, groupIndex) => (
        <div key={groupIndex} className="flex flex-col">
          <button
            onClick={() => onGroupToggle(groupIndex)}
            className="flex items-center gap-2 px-3 py-2 bg-blue-100 hover:bg-blue-200 text-blue-800 rounded-md transition-colors"
          >
            <FontAwesomeIcon
              icon={group.isExpanded ? faChevronDown : faChevronRight}
              className="text-sm"
            />
            <span className="font-medium">{group.title}</span>
            <span className="text-xs bg-blue-300 px-2 py-1 rounded-full">
              {group.columns.length}
            </span>
          </button>
        </div>
      ))}
    </div>
  )
}

export default GroupedColumns
